webpackJsonp([144251824217401],{

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconBase = function IconBase(_ref, _ref2) {
	  var children = _ref.children;
	  var color = _ref.color;
	  var size = _ref.size;
	  var style = _ref.style;
	  var width = _ref.width;
	  var height = _ref.height;
	
	  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);
	
	  var _ref2$reactIconBase = _ref2.reactIconBase;
	  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;
	
	  var computedSize = size || reactIconBase.size || '1em';
	  return _react2.default.createElement('svg', _extends({
	    children: children,
	    fill: 'currentColor',
	    preserveAspectRatio: 'xMidYMid meet',
	    height: height || computedSize,
	    width: width || computedSize
	  }, reactIconBase, props, {
	    style: _extends({
	      verticalAlign: 'middle',
	      color: color || reactIconBase.color
	    }, reactIconBase.style || {}, style)
	  }));
	};
	
	IconBase.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object
	};
	
	IconBase.contextTypes = {
	  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
	};
	
	exports.default = IconBase;
	module.exports = exports['default'];

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(16);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaClockO = function FaClockO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23 12.1v10q0 0.4-0.2 0.6t-0.5 0.2h-7.2q-0.3 0-0.5-0.2t-0.2-0.6v-1.4q0-0.3 0.2-0.5t0.5-0.2h5v-7.9q0-0.3 0.2-0.5t0.6-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m9.3 7.9q0-3.3-1.6-6.1t-4.5-4.4-6.1-1.6-6.1 1.6-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1z m5 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaClockO;
	module.exports = exports['default'];

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(16);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFolderOpen = function FaFolderOpen(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.9 21.2q0 0.6-0.6 1.4l-7.2 8.4q-0.9 1.1-2.5 1.9t-3.1 0.7h-23.1q-0.7 0-1.3-0.3t-0.5-0.9q0-0.6 0.6-1.4l7.2-8.4q0.9-1.1 2.5-1.8t3.1-0.8h23.1q0.7 0 1.3 0.3t0.5 0.9z m-7.2-7.3v3.4h-17.7q-2 0-4.2 1t-3.5 2.5l-7.3 8.6q0-0.1 0-0.3t0-0.3v-20.4q0-1.9 1.4-3.3t3.4-1.4h6.8q1.9 0 3.3 1.4t1.4 3.3v0.7h11.6q1.9 0 3.4 1.4t1.4 3.4z' })
	        )
	    );
	};
	
	exports.default = FaFolderOpen;
	module.exports = exports['default'];

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(16);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTag = function FaTag(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13 10q0-1.2-0.8-2t-2.1-0.9-2 0.9-0.8 2 0.8 2 2 0.9 2.1-0.9 0.8-2z m23.8 12.9q0 1.1-0.8 2l-11 10.9q-0.8 0.9-2 0.9-1.2 0-2-0.9l-16-15.9q-0.8-0.9-1.4-2.3t-0.6-2.6v-9.3q0-1.1 0.8-2t2.1-0.8h9.2q1.2 0 2.7 0.5t2.2 1.5l16 15.9q0.8 0.9 0.8 2.1z' })
	        )
	    );
	};
	
	exports.default = FaTag;
	module.exports = exports['default'];

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutContent = function (_React$Component) {
	  _inherits(AboutContent, _React$Component);
	
	  function AboutContent() {
	    _classCallCheck(this, AboutContent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  AboutContent.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      "div",
	      { className: "about-content", id: "AboutJointly" },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { md: { size: 8, offset: 2 }, sm: 12 },
	            _react2.default.createElement(
	              "h5",
	              null,
	              "Jointly is a platform that empowers couples to manage money better, together.  ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null)
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "People are marrying later and cohabitating earlier, which means we\u2019re bringing more financial baggage to our shared households. Studies show that money fights are a major source of relationship stress and often, a big factor in break-ups and divorce."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "At Jointly, we get it. Managing shared finances has been stressful in our own relationships, and existing tools are almost entirely focused on the individual. We founded Jointly because we want to do better for ourselves and for millions of couples that we know are similarly struggling."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "We believe that personal finance tools are a means to an end\u2014to living the life you want. Jointly is here to guide the conversation and arm you with the resources to make this collaboration fun."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "We believe\u2014and research shows\u2014that when it comes to financial decision-making, two heads are better than one. We\u2019ll provide the app. You provide the hopes and dreams!"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "As we build our platform, we\u2019ll be sharing stories. Some are our own, and some are stories that others have generously shared with us. Join the conversation. Help us spread the word about doing it Jointly!"
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return AboutContent;
	}(_react2.default.Component);
	
	exports.default = AboutContent;
	module.exports = exports["default"];

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hero_Image = __webpack_require__(64);
	
	var _Hero_Image2 = _interopRequireDefault(_Hero_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "agency-about-hero" },
	    _react2.default.createElement(
	      "section",
	      { className: "container" },
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "hero-text" },
	          _react2.default.createElement(
	            "p",
	            { className: "customFadeInUp" },
	            "We envision a world where managing household finances is collaborative, and couples work as a team."
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Hero_Image2.default, { imageSharp: props.heroImage })
	  );
	};
	
	exports.default = Hero;
	module.exports = exports["default"];

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(14);
	
	var _RavenBWSquareSm = __webpack_require__(455);
	
	var _RavenBWSquareSm2 = _interopRequireDefault(_RavenBWSquareSm);
	
	var _jeremyBwSqSm = __webpack_require__(456);
	
	var _jeremyBwSqSm2 = _interopRequireDefault(_jeremyBwSqSm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Features = function (_React$Component) {
	  _inherits(Features, _React$Component);
	
	  function Features() {
	    _classCallCheck(this, Features);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Features.prototype.render = function render() {
	    var iconStyle = { color: "#fff" };
	    var iconSize = 50;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "agency-about-team", id: "Team" },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          "h4",
	          null,
	          "The Founders"
	        ),
	        _react2.default.createElement("hr", null),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Our team is experienced in building financial products & software"
	        ),
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { md: 6, className: "team-member" },
	            _react2.default.createElement(
	              "div",
	              { className: "member" },
	              _react2.default.createElement(
	                "div",
	                { className: "mask" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://twitter.com/says_theraven" },
	                  _react2.default.createElement("i", { className: "fa fa-twitter" })
	                ),
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://www.linkedin.com/in/raven-smith-6511011" },
	                  _react2.default.createElement("i", { className: "fa fa-linkedin" })
	                )
	              ),
	              _react2.default.createElement("img", { src: _RavenBWSquareSm2.default, width: "100%", height: "100%" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "name" },
	              "Raven Smith"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "description" },
	              "Raven is a financial services expert, who has spent most of her career building and distributing new consumer financial products. She also has experience in a B2B environment, including spending three years as a strategy and innovation consultant at Innosight, where she helped large companies create new growth businesses in brilliantly disruptive ways. She holds an MBA from Harvard, and she\u2019s passionate about sharing access to the knowledge and tools that help everyone live their best financial life."
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { md: 6, className: "team-member" },
	            _react2.default.createElement(
	              "div",
	              { className: "member" },
	              _react2.default.createElement(
	                "div",
	                { className: "mask" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://twitter.com/all9lives" },
	                  _react2.default.createElement("i", { className: "fa fa-twitter" })
	                ),
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://www.linkedin.com/in/jeremybrennan/" },
	                  _react2.default.createElement("i", { className: "fa fa-linkedin" })
	                )
	              ),
	              _react2.default.createElement("img", { src: _jeremyBwSqSm2.default, width: "100%", height: "100%" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "name" },
	              "Jeremy Brennan"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "description" },
	              "Jeremy is a techie with a background in finance and media. He worked at Excite and Citigroup, before joining LearnVest, a subscription based financial planning platform acquired by Northwestern Mutual in 2015. As the company\u2019s second engineer, Jeremy helped build both LearnVest\u2019s tech platform and team. He believes that with the right tools, we can all be more successful\u2014both financially and in our relationships."
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Features;
	}(_react2.default.Component);
	
	exports.default = Features;
	module.exports = exports["default"];

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Bg_Image = __webpack_require__(41);
	
	var _Bg_Image2 = _interopRequireDefault(_Bg_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import moment from 'moment'
	// import { Container, Row, Col, Form, Label, Input, Button } from 'reactstrap';
	// import Link from 'gatsby-link'
	
	var HeroImage = function (_React$Component) {
	  _inherits(HeroImage, _React$Component);
	
	  function HeroImage(props) {
	    _classCallCheck(this, HeroImage);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  HeroImage.prototype.render = function render() {
	
	    // Expects featured_meda prop
	    var ImageSharp = this.props.imageSharp;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'hero-background ' + this.props.className },
	      _react2.default.createElement(_Bg_Image2.default, {
	        resolutions: ImageSharp.resolutions,
	        sizes: ImageSharp.sizes,
	        className: 'hero-background-image',
	        fadeIn: true
	      })
	    );
	  };
	
	  return HeroImage;
	}(_react2.default.Component);
	
	exports.default = HeroImage;
	
	
	HeroImage.defaultProps = {
	  className: ''
	};
	module.exports = exports['default'];

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Raven-BW-Square-sm.71269a78.jpg";

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/jeremy-bw-sq-sm.5fd80c70.jpeg";

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(14);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _clockO = __webpack_require__(126);
	
	var _clockO2 = _interopRequireDefault(_clockO);
	
	var _tag = __webpack_require__(61);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _folderOpen = __webpack_require__(127);
	
	var _folderOpen2 = _interopRequireDefault(_folderOpen);
	
	var _Hero = __webpack_require__(183);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Team = __webpack_require__(184);
	
	var _Team2 = _interopRequireDefault(_Team);
	
	var _About_Content = __webpack_require__(182);
	
	var _About_Content2 = _interopRequireDefault(_About_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import PostIcons from '../components/PostIcons'
	
	// import { rhythm } from '../utils/typography'
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  About.prototype.render = function render() {
	
	    console.log('props.data', this.props.data);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'about' },
	      _react2.default.createElement(_Hero2.default, { heroImage: this.props.data.heroImage }),
	      _react2.default.createElement(_About_Content2.default, null),
	      _react2.default.createElement(_Team2.default, null)
	    );
	  };
	
	  return About;
	}(_react.Component);
	
	exports.default = About;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-jsx-d1492e251aef53c4d38c.js